<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control">
            <div class="body-panel-control separator" v-if="project && info.User && (hasClaims(info.User.DynamicRole, claimEnums.ratingExport) ||
            info.User.MainRole === 'administrators' || (hasClaims(info.User.DynamicRole, claimEnums.ratingSwitcher) && project.RatingSwitcherEnabled && ratingRoles.length) )">
                <div class="body-panel-control-separator">
                    <div class="control-block-left">
                        <div class="flex" v-if="info.User.MainRole === 'administrators' || info.ProjectsLength > 1 || (project.RatingSwitcherEnabled && ratingRoles.length && hasClaims(info.User.DynamicRole, claimEnums.ratingSwitcher))">
                            <project-select :user="info.User" @onChange="onProjectChange" v-if="(info.User.MainRole === 'administrators' || info.ProjectsLength > 1)"></project-select>

                            <div class="form-field margin-right-10" v-if="project.RatingSwitcherEnabled && ratingRoles.length > 1 && (info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.ratingSwitcher))">
                                <drop-down :items="ratingRoles"
                                           :dataField="'Value'"
                                           :textField="'Name'"
                                           v-model="ratingRole"
                                           @change="reload"></drop-down>

                            </div>
                        </div>

                    </div>

                    <div class="control-block-right" v-if="(hasClaims(info.User.DynamicRole, claimEnums.ratingExport) || info.User.MainRole === 'administrators')">

                        <button class="btn" @click="onExport()">
                            Экспорт
                        </button>

                    </div>
                </div>
                <div class="body-panel-control-separator" v-if="!isDaccordUser">
                    <complex-filter ref="complexFilter"
                                    :filters="filters"
                                    :searchFunction="searchFunction"
                                    :tableName="'[dbo].[TradePoint]'"
                                    :withTableNameInClause="true"
                                    @onFilterChange="onFilterChange">
                    </complex-filter>
                </div>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page">
            <!--<div class="block-in-page" style="height:100%">-->

                <table class="t-data" id="dataTable" style="max-width:1000px;margin:0 auto" v-if="project">
                    <thead>
                        <tr class="heading">
                            <th class="fix"></th>
                            <th class="number">Место</th>
                            <th class="with-img mob-hide">Участник</th>
                            <th class="w150-r sortable" @click.stop="sort('BonusesAmountMonth')" v-if="!project.RatingColumn2AsPercent">
                                <template v-if="project.RatingColumn1 && project.RatingColumn1 !== 'ТекМесяцГод'">{{project.RatingColumn1}}</template>
                                <template v-else>
                                    <template v-if="projectId === 1 && ratingRole === 'distr'">
                                        ТОП-10 август-сентябрь
                                    </template>
                                    <template v-else>
                                        {{currentMonth()}}
                                    </template>
                                </template>

                                <template v-if="sortColumn === 'BonusesAmountMonth'">
                                    <span v-if="sortDirection === 'desc'" class="margin-left-5"><img src="../../img/arrow-down.png" class="sort-img" /></span>
                                    <span v-if="sortDirection === 'asc'" class="margin-left-5"><img src="../../img/arrow-up.png" class="sort-img" /></span>
                                </template>
                            </th>
                            <th class="w150-r sortable" @click.stop="sort('BonusesAmount')">
                                <template v-if="project.RatingColumn2">{{project.RatingColumn2}}</template>
                                <template v-else>Всего</template>

                                <template v-if="sortColumn === 'BonusesAmount'">
                                    <span v-if="sortDirection === 'desc'" class="margin-left-5"><img src="../../img/arrow-down.png" class="sort-img" /></span>
                                    <span v-if="sortDirection === 'asc'" class="margin-left-5"><img src="../../img/arrow-up.png" class="sort-img" /></span>
                                </template>
                            </th>
                            <th class="fix-2"></th>
                        </tr>
                    </thead>
                    <tbody @scroll="onScroll">
                        <template v-for="item of data">
                            <tr v-if="data.length > 2 && (item.Place - 1 > data[data.length - 2].Place) && item.Selected">
                                <td colspan="3">
                                    &nbsp;
                                </td>
                            </tr>
                            <!--чисто для мобильного браузера-->
                            <tr :class="['', {'selected': item.Selected}]" v-if="isMobile">
                                <td class="number">
                                    <img :src="item.UserImage" v-if="item.UserImage !== null" />
                                    <img src="../../img/u57.png" v-else-if="faceDefault !== null" />
                                </td>
                                <td class="with-img">
                                    <span v-html="item.Fio"></span>
                                </td>
                            </tr>
                            <tr :class="{'selected': item.Selected}">
                                <td class="number">
                                    {{ item.Place }}
                                </td>
                                <td class="with-img" v-if="!isMobile">
                                    <img :src="item.UserImage" v-if="item.UserImage !== null" />
                                    <img src="../../img/u57.png" v-else-if="faceDefault !== null" />
                                    <span v-html="item.Fio"></span>
                                </td>
                                <td class="w150-r" style="text-align:center" v-if="!project.RatingColumn2AsPercent">{{ formatInt(item.BonusesAmountMonth) }}</td>
                                <td class="w150-r" style="text-align:center">{{Column2Value(item)}}</td>
                            </tr>
                        </template>

                    </tbody>
                </table>

            <!--</div>-->
        </div>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import UI from '../helpers/ui-helpers'
    import config from '../config'

    let backendApi = new BackendApi();
    let projectIdMDV = 32;
    let projectDaccord = 39;
    const pageSize = 50;

    export default {
        name: "rating-new",

        props: ['info'],

        mixins: [projectMixin],

        data(){
            return {
                data: [],
                ratingRoles: [],
                loading: false,
                canBeLoaded: true,
                page: 1,
                filter: null,
                filters: [],
                roles: [],
                sortColumn: 'BonusesAmountMonth',
                sortDirection: 'desc',
                project: null,
                ratingRole: null,
                isMobile: UI.check_mobile(),
                faceDefault: '../../img/u57.png',
                projectId: null
            }
        },

        methods: {
            Column2Value(item) {
                if(item.Column2String && item.Column2String.length > 0)
                    return item.Column2String;
                else if(this.project.RatingColumn2AsPercent === true)
                    return this.formatInt(Math.floor(item.BonusesAmount * 100)).toString() + '%';
                else
                    return this.formatInt(item.BonusesAmount).toString();
            },

            reload(){
                this.page = 1;
                this.canBeLoaded = true;
                this.data = [];

                this.loadNext();
            },

            sort(columnName){
                let vm = this;
                if(vm.sortColumn == null || vm.sortColumn !== columnName){
                    vm.sortDirection = 'desc';
                }else{
                    vm.sortDirection = vm.sortDirection === 'desc' ? 'asc': 'desc';
                }
                vm.sortColumn = columnName;

                vm.reload();
            },

            loadRoles() {
                let vm = this;
                let projectId = vm.projectId;
                //data.isMobile = UI.check_mobile();
                vm.filters = [
                    {
                        Value: 'Name', Name: 'Название'
                    },
                    {
                        Value: 'Region', Name: 'Регион'
                    },
                    {
                        Value: 'Area', Name: 'Область'
                    },
                    {
                        Value: 'City', Name: 'Город'
                    },
                    {
                        Value: 'Address', Name: 'Адрес'
                    }
                ];
                return this.callApiWrapper(backendApi.rolesList(projectId))
                    .then(function (resp) {
                        if (resp.data) {

                            vm.roles = resp.data.Roles;

                            /*
                            для ролей соблюдаем иерархию, согласно последовательности отображения в настройках ролей
                            если роль не связана с ТТ, то она видит все роли связанные с ТТ
                            если роль связана с ТТ, то видит только роли, которые стоят ниже нее
                            */
                            if(vm.info.User.DynamicRole == null || vm.info.User.DynamicRole.Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess))
                            {
                                //alert()
                                for(let r = 0; r < vm.roles.length; r++) {
                                    if (vm.projectId === projectDaccord) {
                                        if (vm.roles[r].Name === vm.ratingRole &&
                                            !vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {
                                            vm.filters.push({
                                                Value: 'TradePointRole_' + vm.roles[r].Id,
                                                Name: vm.roles[r].Name
                                            });
                                        }
                                    }
                                    // Для всех остальных projectId продолжаем добавлять роли, как обычно
                                    else {
                                        if (!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {
                                            vm.filters.push({
                                                Value: 'TradePointRole_' + vm.roles[r].Id,
                                                Name: vm.roles[r].Name
                                            });
                                        }
                                    }
                                }
                            }
                            else{

                                for(let r = 0; r < vm.roles.length; r++) {
                                    if (!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess) && vm.info.User.DynamicRole.Order < vm.roles[r].Order) {

                                        vm.filters.push({
                                            Value: 'TradePointRole_' + vm.roles[r].Id,
                                            Name: vm.roles[r].Name
                                        });
                                    }
                                }
                            }
                        }
                    });
            },

            loadSettings(){
                let vm = this;

                return this.callApiWrapper(backendApi.ratingSettings()).then(function (resp) {
                    if(resp.data) {
                        vm.project = resp.data.project;
                        vm.ratingRole = null;
                        if(vm.project.RatingSwitcherEnabled && vm.info.User && (vm.info.User.MainRole === 'administrators' || vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.ratingSwitcher))) {
                            if(vm.project.RatingRoles) {
                                vm.ratingRoles = vm.project.RatingRoles;
                            }
                            if(vm.info.User.MainRole === 'administrators') {
                                if(vm.ratingRoles.some(x => x.ByDefault === true)) {
                                    vm.ratingRole = vm.ratingRoles.find(x => x.ByDefault === true).Value;
                                }
                            } else {
                                let currentRole = vm.info.User.UserDynamicRoles.find(x => x.ProjectId === vm.projectId);
                                if(vm.projectId === 1) {
                                    if(currentRole && currentRole.DefaultProjectRatingRole) {
                                        vm.ratingRole = currentRole.DefaultProjectRatingRole;
                                    } else if(vm.ratingRoles.some(x => x.ByDefault === true)) {
                                        vm.ratingRole = vm.ratingRoles.find(x => x.ByDefault === true).Value;
                                    }
                                } else if(vm.ratingRoles) {
                                    if(currentRole) {
                                        vm.ratingRoles = vm.ratingRoles.filter(x => x.Value == currentRole.RoleName);
                                        if(!vm.ratingRoles || vm.ratingRoles.length === 0)
                                            vm.ratingRoles = vm.project.RatingRoles;
                                    } 
                                    if(vm.ratingRoles.some(x => x.ByDefault === true)) {
                                        vm.ratingRole = vm.ratingRoles.find(x => x.ByDefault === true).Value;
                                    } else if(vm.ratingRoles.length > 0) {
                                        vm.ratingRole = vm.ratingRoles[0].Value;
                                    }
                                }
                            }
                        }
                        if(vm.projectId === projectIdMDV || vm.projectId === 2) {
                            vm.faceDefault = null;
                        } else {
                            vm.faceDefault = '../../img/u57.png';
                        }
                    }
                });
            },

            onScroll(e){
                let vm = this;
                let elem = $(e.target);
                if(!vm.loading && vm.canBeLoaded && elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.page++;
                    vm.loadNext();
                }
            },

            loadNext(){
                let vm = this;

                vm.loading = true;
                let projectId = vm.projectId;
                let filterFormatted = '';
                if(this.filter){
                    filterFormatted = this.filter.map(x => {return JSON.stringify(x)});
                }
                
                UI.blockUI('.dataContent', 'Загрузка...');
                this.callApiWrapper(backendApi.ratingGetTop((vm.page - 1) * pageSize, pageSize, projectId, filterFormatted, vm.sortColumn, vm.sortDirection, vm.ratingRole)).then(function (resp) {
                    if (resp.hasError && resp.status !== 401) {
                        UI.toastr.error('Ошибка во время загрузки данных');
                    }
                    else {
                        //console.log('vm.data', vm.data);
                        if(resp.data && resp.data.length) {
                            let currentUserId = vm.info.User.Id;

                            console.log(resp.data)

                          if (vm.projectId === projectDaccord) {
                                resp.data = resp.data.map(item => {
                                    return {
                                        ...item,
                                        BonusesAmount: Math.round(item.BonusesAmount), // Округляем общий бонус
                                        BonusesAmountMonth: Math.round(item.BonusesAmountMonth) // Округляем бонус за месяц
                                    };
                                });
                            }

                            // Проверка на projectId 39 и роль "Сантехник" или "Продавец"
                            if (vm.isDaccordUser) {
                                // Оставляем только 15 записей
                                let top15 = resp.data.slice(0, 15);

                                // Проверяем, есть ли текущий пользователь среди первых 15
                                let userInTop15 = top15.find(item => item.UserId === currentUserId);

                                if (!userInTop15) {
                                    // Если текущего пользователя нет в первых 15, добавляем его в список
                                    let currentUserData = resp.data.find(item => item.UserId === currentUserId);

                                    if (currentUserData) {
                                        top15.push(currentUserData); // Добавляем текущего пользователя
                                    }
                                }

                                // Обновляем данные
                                vm.data.push(...top15);
                            } else {
                                // Если не projectId 39 или не "Сантехник"/"Продавец", добавляем все записи
                                vm.data.push(...resp.data);
                            }
                        }
                        else{
                            vm.canBeLoaded = false;
                        }
                    }

                    UI.unblockUI('.dataContent');
                    vm.loading = false;
                });
                if(vm.projectId === projectDaccord)
                  this.loadRoles()
            },

            onProjectChange(item) {
                let vm = this;
                
                vm.projectId = item.Id;
                vm.sortDirection = 'desc';
                vm.sortColumn = 'BonusesAmount';

                Promise.all([vm.loadRoles(), vm.loadSettings()]).then(() => {
                    vm.reload();
                });

                vm.$emit('user-updated');
            },

            searchFunction(tableName, columnName, search, filters, searchPage, callback) {

                let projectId = this.projectId;
                let filterFormatted = '';
                if(filters){
                    filterFormatted = filters.map(x => {return JSON.stringify(x)});
                }

                this.callApiWrapper(backendApi.ratingDistinctValues(columnName, projectId, search, filterFormatted, (searchPage - 1) * 30, 30))
                    .then(function (resp) {
                        callback(resp.data);
                    })

            },

            onFilterChange(filter) {
                this.filter = filter;
                this.reload();
            },

            onExport() {
                let projectId = this.projectId;
                let filterFormatted = '';
                if(this.filter){
                    filterFormatted = this.filter.map(x => {return JSON.stringify(x)});
                }

                UI.blockUI('#app');
                this.callApiWrapper(backendApi.ratingExport(projectId, filterFormatted, this.sortColumn, this.sortDirection, this.ratingRole))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            UI.downloadFileByBytes(resp.data, "Рейтинг участников.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                        }

                        UI.unblockUI('#app');
                    });
            },
        },

        computed: {
          isDaccordUser() {
              let currentRole = this.info.User.UserDynamicRoles.find(x => x.ProjectId === this.projectId);
              return this.projectId === projectDaccord && (currentRole && (currentRole.RoleName === 'Электрик' || currentRole.RoleName === 'Продавец'));
          }
        },

        mounted(){
            let vm = this;
            if(localStorage.getItem('selectedProjectId'))
                vm.projectId = parseInt(localStorage.getItem('selectedProjectId'));

            Promise.all([vm.loadRoles(), vm.loadSettings()]).then(() => {
                vm.loadNext();
            });
        }
    }
</script>

<style scoped>
    .table-view thead{
        display: table-row-group;
    }
    .heading .sortable{cursor: pointer;}
    
</style>


// WEBPACK FOOTER //
// Content/src/views/RatingNew.vue